// src/shared/api/ExtPlatApi.ts

import { webApi } from '@/shared/api/WebApi';
import type { IListRes } from '@lib2/model/common/ListRes';
import type {
  IExtPlatAuthView,
  IExtPlatAuthCreateOrUpdateReq,
  IExtPlatAuthCheckTokensReq,
} from '@/lib/types/Simulcast';
import type { IFBLocations } from '@/lib/types/Simulcast';

const SEGMENT = 'extplatauth';

export class ExtPlatApi {
  /** Fetch all external platform auths for a customer. */
  static async getExtPlatAuths(cId: number): Promise<IListRes<IExtPlatAuthView>> {
    return webApi.get<IListRes<IExtPlatAuthView>>(SEGMENT, { cId });
  }

  /** Fetch single external platform auth by ID. */
  static async getExtPlatAuth(cId: number, extPlatAuthId: number): Promise<IExtPlatAuthView> {
    return webApi.get<IExtPlatAuthView>(`${SEGMENT}/${extPlatAuthId}`, { cId });
  }

  /** Create new external platform auth. */
  static async createExtPlatAuth(cId: number, req: IExtPlatAuthCreateOrUpdateReq): Promise<IExtPlatAuthView> {
    return webApi.post<IExtPlatAuthView>(SEGMENT, { cId }, req);
  }

  /** Update existing external platform auth. */
  static async updateExtPlatAuth(cId: number, extPlatAuthId: number, req: IExtPlatAuthCreateOrUpdateReq): Promise<IExtPlatAuthView> {
    return webApi.post<IExtPlatAuthView>(`${SEGMENT}/${extPlatAuthId}`, { cId }, req);
  }

  /** Fetch Facebook locations for a given ExtPlatAuth. */
  static async getFacebookLocations(cId: number, extPlatAuthId: number): Promise<IFBLocations> {
    return webApi.get<IFBLocations>(`${SEGMENT}/${extPlatAuthId}/fb/locations`, { cId });
  }

  /** Check auth tokens for given ExtPlatAuth IDs. Returns updated auth views. */
  static async checkAuthTokens(cId: number, req: IExtPlatAuthCheckTokensReq): Promise<IExtPlatAuthView[]> {
    return webApi.post<IExtPlatAuthView[]>(`${SEGMENT}/check-auth-tokens`, { cId }, req);
  }
}
